export const beastList = [
  { key: 'dragon', desc: 'Dragon', img: '', info: '' },
  { key: 'panda', desc: 'Panda', img: '', info: '' },
  { key: 'pegasus', desc: 'Pegasus', img: '', info: '' },
  { key: 'phoenix', desc: 'Phoenix', img: '', info: '' }
]

export const beastSkillsTemplates = [
  { k: 1, desc: 'Anti Cav / Archer', skills: ['antiCavalry', 'forceExpansion', 'steelSkin', 'antiInfantry'] },
  { k: 2, desc: 'Anti Cav / Mage', skills: ['antiCavalry', 'forceExpansion', 'resistMagic', 'antiInfantry'] },
  { k: 3, desc: 'Anti Inf / Archer', skills: ['antiInfantry', 'forceExpansion', 'steelSkin', 'antiCavalry'] },
  { k: 4, desc: 'Anti Inf / Mage', skills: ['antiInfantry', 'forceExpansion', 'resistMagic', 'antiCavalry'] },
  { k: 5, desc: 'Development', skills: ['recruitmentSpeedUp', 'quickHeal', 'woundedConversion', 'levelUpBooster'] },
  { k: 6, desc: 'EW', skills: ['resistMagic', 'steelSkin', 'antiAngel', 'antiInfantry'] },
  { k: 7, desc: 'EW 2', skills: ['smotheredFlare', 'resistMagic', 'antiCavalry', 'antiInfantry'] },
  { k: 8, desc: 'BV / WoE - II', skills: ['smotheredFlare', 'resistMagic', 'steelSkin', 'antiAngel'] },
  { k: 9, desc: 'BV / WoE - II', skills: ['smotheredFlare', 'resistMagic', 'steelSkin', 'antiAngel'] },
  { k: 10, desc: 'Monsters', skills: ['levelUpBooster', 'attackExpert', 'lifeSource', 'forceExpansion'] },
  { k: 11, desc: 'PvE', skills: ['attackExpert', 'lifeSource', 'forceExpansion', ''] },
  { k: 12, desc: 'WAR', skills: ['forceExpansion', 'antiCavalry', 'antiInfantry', 'resistMagic'] },
  { k: 13, desc: 'Wounded - Healing', skills: ['woundedLimit', 'woundedConversion', 'quickHeal', ''] }
]

export const beastSkills = {
  slots: [
    {
      key: 1,
      level: 1,
      expNeeded: 0,
      maxLevel: 30,
      minLevel: 1,
      skill: {},
      requeriments: 'Beast Lvl 10. Beast Evolution 3.'
    },
    {
      key: 2,
      level: 1,
      expNeeded: 0,
      maxLevel: 30,
      minLevel: 1,
      skill: {},
      requeriments: 'Beast Lvl 15. Beast Evolution 4.'
    },
    {
      key: 3,
      level: 1,
      expNeeded: 0,
      maxLevel: 30,
      minLevel: 1,
      skill: {},
      requeriments: 'Beast Lvl 20. Beast Evolution 5.'
    },
    {
      key: 4,
      level: 1,
      expNeeded: 0,
      maxLevel: 30,
      minLevel: 1,
      skill: {},
      requeriments: 'Beast Lvl 25. Beast Evolution 6.'
    }
  ],
  skillLevel: [
    { level: 2, exp: 150 },
    { level: 3, exp: 250 },
    { level: 4, exp: 300 },
    { level: 5, exp: 400 },
    { level: 6, exp: 500 },
    { level: 7, exp: 600 },
    { level: 8, exp: 750 },
    { level: 9, exp: 900 },
    { level: 10, exp: 1350 },
    { level: 11, exp: 1650 },
    { level: 12, exp: 2000 },
    { level: 13, exp: 2400 },
    { level: 14, exp: 2900 },
    { level: 15, exp: 4350 },
    { level: 16, exp: 5250 },
    { level: 17, exp: 6300 },
    { level: 18, exp: 7600 },
    { level: 19, exp: 9150 },
    { level: 20, exp: 11000 },
    { level: 21, exp: 13200 },
    { level: 22, exp: 15850 },
    { level: 23, exp: 19500 },
    { level: 24, exp: 24900 },
    { level: 25, exp: 33500 },
    { level: 26, exp: 45500 },
    { level: 27, exp: 50350 },
    { level: 28, exp: 53000 },
    { level: 29, exp: 55600 },
    { level: 30, exp: 61250 }
  ],
  beastSkillList: [
    {
      key: 'antiAngel',
      group: 'WAR',
      desc: 'Anti-Angel',
      info: 'For troops attacking Angels, damage is increased by $1%.',
      statInit: 1.6,
      statInc: 0.9
    },
    {
      key: 'antiCavalry',
      group: 'WAR',
      desc: 'Anti-Cavalry',
      info: 'For troops attacking Cavalry, damage is increased by $1%.',
      statInit: 1.6,
      statInc: 0.9
    },
    {
      key: 'antiInfantry',
      group: 'WAR',
      desc: 'Anti-Infantry',
      info: 'For troops attacking Infantry, damage is increased by $1%.',
      statInit: 1.6,
      statInc: 0.9
    },
    {
      key: 'attackExpert',
      group: 'WAR',
      desc: 'Attack Expert',
      info: 'Raises Attack of all Troops by $1%.',
      statInit: 1.6,
      statInc: 0.8
    },
    {
      key: 'forceExpansion',
      group: 'WAR',
      desc: 'Force Expansion',
      info: 'Raises max size of marching army by $1%.',
      statInit: 1,
      statInc: 0.5
    },
    {
      key: 'levelUpBooster',
      group: 'Development',
      desc: 'Level Up Booster',
      info: 'Increases XP from defeating Monsters by $1%.',
      statInit: 1.6,
      statInc: 0.8
    },
    {
      key: 'lifeSource',
      group: 'WAR',
      desc: 'Life Source',
      info: 'Raises Max HP of all Troops by $1%.',
      statInit: 1.6,
      statInc: 0.8
    },
    {
      key: 'marchSpeedUp',
      group: 'Misc',
      desc: 'March Speed Up',
      info: 'Raises marching army speed by $1%.',
      statInit: 2,
      statInc: 1
    },
    {
      key: 'quickHeal',
      group: 'WAR',
      desc: 'Quick Heal',
      info: 'Raises healing speed for wounded soldiers by $1%.',
      statInit: 1.6,
      statInc: 0.8
    },
    {
      key: 'recruitmentSpeedUp',
      group: 'Development',
      desc: 'Recruitment Speed Up',
      info: 'Raises soldier recruitment speed by $1%.',
      statInit: 1,
      statInc: 0.5
    },
    {
      key: 'resistMagic',
      group: 'WAR',
      desc: 'Resist Magic',
      info: 'When troops are attacked by Mages, damage taken is reduced by $1%.',
      statInit: 2,
      statInc: 1.1
    },
    {
      key: 'smotheredFlare',
      group: 'WAR',
      desc: 'Smothered Flare',
      info: 'When troops are attacked by Angels, damage taken is reduced by $1%.',
      statInit: 2,
      statInc: 1.1
    },
    {
      key: 'steelSkin',
      group: 'WAR',
      desc: 'Steel Skin',
      info: 'When troops are attacked by Archers, damage taken is reduced by $1%.',
      statInit: 2,
      statInc: 1.1
    },
    {
      key: 'woundedConversion',
      group: 'Misc',
      desc: 'Wounded Conversion',
      info: 'Increases ratio of killed soldiers converted to wounded at battle end by $1%.',
      statInit: 0.8,
      statInc: 0.4
    },
    {
      key: 'woundedLimit',
      group: 'WAR',
      desc: 'Wounded Limit',
      info: 'Increases max limit of wounded soldiers in the Hospital by $1%.',
      statInit: 13.2,
      statInc: 1
    },
    {
      key: 'vigorStar',
      group: 'Development',
      desc: 'Vigor Star',
      info: 'Decreases recovery time for each point of Vigor $1%.',
      statInit: 1,
      statInc: 1
    }
  ]
}

export const dataOptions = [
  {
    row: 'A',
    col: 1,
    type: 1,
    beast: 'all',
    description: 'Beast Showdown',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    dependency: 0,
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      'Beast will additionally deal Damage by $1% of Normal Attack randomly agaisnt an enemy Beast every 8 seconds.',
    levels: [
      { level: 1, points: 120, stat: [22] },
      { level: 2, points: 130, stat: [44] },
      { level: 3, points: 135, stat: [67] },
      { level: 4, points: 140, stat: [90] },
      { level: 5, points: 150, stat: [113] },
      { level: 6, points: 155, stat: [137] },
      { level: 7, points: 165, stat: [161] },
      { level: 8, points: 175, stat: [186] },
      { level: 9, points: 180, stat: [212] },
      { level: 10, points: 190, stat: [237] },
      { level: 11, points: 200, stat: [263] },
      { level: 12, points: 210, stat: [290] },
      { level: 13, points: 220, stat: [317] },
      { level: 14, points: 230, stat: [344] },
      { level: 15, points: 245, stat: [372] }
    ]
  },
  {
    row: 'B',
    col: 1,
    type: 2,
    beast: 'all',
    description: 'Beast Inspiration',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [{ row: 'A', col: 1, minLevel: 1 }],
    curLevel: 0,
    curTotalPoints: 0,
    statText: 'Increases HP and Attack of Infantry and Cavalry by $1.',
    levels: [
      { level: 1, points: 220, stat: [1.3] },
      { level: 2, points: 230, stat: [2.6] },
      { level: 3, points: 240, stat: [3.9] },
      { level: 4, points: 255, stat: [5.3] },
      { level: 5, points: 265, stat: [6.7] },
      { level: 6, points: 280, stat: [8.1] },
      { level: 7, points: 295, stat: [9.6] },
      { level: 8, points: 310, stat: [11.1] },
      { level: 9, points: 325, stat: [12.6] },
      { level: 10, points: 340, stat: [14.1] },
      { level: 11, points: 360, stat: [15.6] },
      { level: 12, points: 380, stat: [17.2] },
      { level: 13, points: 395, stat: [18.8] },
      { level: 14, points: 415, stat: [20.4] },
      { level: 15, points: 440, stat: [22] }
    ]
  },
  {
    row: 'B',
    col: 2,
    type: 2,
    beast: 'any',
    description: 'Troops Converted Attack',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [{ row: 'A', col: 1, minLevel: 1 }],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      "Increases Attack of your Beast during battle. The increased amount is (your Troops' Total Battle Power) x $1%. The max limit of the increased Attack is $2.",
    levels: [
      { level: 1, points: 90, stat: [3.6, 88700] },
      { level: 2, points: 95, stat: [7.2, 177400] },
      { level: 3, points: 100, stat: [10.8, 266100] },
      { level: 4, points: 105, stat: [14.4, 354800] },
      { level: 5, points: 110, stat: [18, 443500] },
      { level: 6, points: 115, stat: [21.7, 535000] },
      { level: 7, points: 120, stat: [25.4, 626500] },
      { level: 8, points: 125, stat: [29.1, 718000] },
      { level: 9, points: 130, stat: [32.8, 809500] },
      { level: 10, points: 135, stat: [36.5, 901000] },
      { level: 11, points: 140, stat: [40.3, 993800] },
      { level: 12, points: 145, stat: [44.1, 1086600] },
      { level: 13, points: 150, stat: [47.9, 1179400] },
      { level: 14, points: 160, stat: [51.7, 1272200] },
      { level: 15, points: 170, stat: [55.5, 1365000] }
    ]
  },
  {
    row: 'C',
    col: 1,
    type: 1,
    beast: 'any',
    description: 'Potential Awakening',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [{ row: 'A', col: 1, minLevel: 1 }],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      "Beast increases its HP by $1% and Attack by $2% every 4 seconds during the battle (can be stacked up to $3 times). After being stacked to the max, the Beast's potential completely breaks out, increasing the Attack of your Troops by $4%.",
    levels: [
      { level: 1, points: 310, stat: [1, 1, 4, 1] },
      { level: 2, points: 330, stat: [2, 2, 4, 2] },
      { level: 3, points: 355, stat: [3, 3, 4, 3] },
      { level: 4, points: 380, stat: [4, 4, 4, 4] },
      { level: 5, points: 405, stat: [5, 5, 4, 5] },
      { level: 6, points: 430, stat: [5.9, 5.9, 4, 6] },
      { level: 7, points: 460, stat: [6.8, 6.8, 4, 7] },
      { level: 8, points: 490, stat: [7.7, 7.7, 4, 8] },
      { level: 9, points: 520, stat: [8.6, 8.6, 4, 9] },
      { level: 10, points: 560, stat: [9.5, 9.5, 4, 10] },
      { level: 11, points: 600, stat: [10.4, 10.4, 4, 11] },
      { level: 12, points: 640, stat: [11.3, 11.3, 4, 12] },
      { level: 13, points: 690, stat: [12.2, 12.2, 4, 13] },
      { level: 14, points: 740, stat: [13.1, 13.1, 4, 14] },
      { level: 15, points: 790, stat: [14, 14, 4, 15] }
    ]
  },
  {
    row: 'D',
    col: 1,
    type: 2,
    beast: 'all',
    description: "Beast's Growl",
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 3 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText: 'Increases HP and Attack of Archers and Mages by $1%.',
    levels: [
      { level: 1, points: 255, stat: [1.3] },
      { level: 2, points: 270, stat: [2.6] },
      { level: 3, points: 285, stat: [3.9] },
      { level: 4, points: 295, stat: [5.3] },
      { level: 5, points: 310, stat: [6.7] },
      { level: 6, points: 330, stat: [8.1] },
      { level: 7, points: 345, stat: [9.6] },
      { level: 8, points: 360, stat: [11.1] },
      { level: 9, points: 380, stat: [12.6] },
      { level: 10, points: 400, stat: [14.1] },
      { level: 11, points: 420, stat: [15.6] },
      { level: 12, points: 440, stat: [17.2] },
      { level: 13, points: 465, stat: [18.8] },
      { level: 14, points: 485, stat: [20.4] },
      { level: 15, points: 510, stat: [22] }
    ]
  },
  {
    row: 'D',
    col: 2,
    type: 2,
    beast: 'any',
    description: 'Troops Converted HP',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 3 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      "Increases HP of your Beast during battle. The increased amount is (your Troops' battle power) x $1%. The max limit of the increased HP is $2.",
    levels: [
      { level: 1, points: 100, stat: [112, 2730000] },
      { level: 2, points: 105, stat: [224, 5460000] },
      { level: 3, points: 110, stat: [336, 8190000] },
      { level: 4, points: 115, stat: [448, 10920000] },
      { level: 5, points: 120, stat: [560, 13650000] },
      { level: 6, points: 125, stat: [676, 16464000] },
      { level: 7, points: 130, stat: [792, 19278000] },
      { level: 8, points: 135, stat: [908, 22092000] },
      { level: 9, points: 140, stat: [1024, 24906000] },
      { level: 10, points: 150, stat: [1140, 27720000] },
      { level: 11, points: 160, stat: [1257, 30576000] },
      { level: 12, points: 170, stat: [1374, 33432000] },
      { level: 13, points: 180, stat: [1491, 36288000] },
      { level: 14, points: 190, stat: [1608, 39144000] },
      { level: 15, points: 200, stat: [1725, 42000000] }
    ]
  },
  {
    row: 'E',
    col: 1,
    type: 1,
    beast: 'any',
    description: 'Vigor Drain',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 3 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      'During the first 30 seconds of battle. Beast recovers its HP by $1% of Damage dealt when its Normal Attack hits the target and reduces the Attack of the hit target by $2%. The attack reduction effect lasts until the battle is over.',
    levels: [
      { level: 1, points: 200, stat: [3.6, 2] },
      { level: 2, points: 210, stat: [7.2, 4] },
      { level: 3, points: 220, stat: [10.6, 6] },
      { level: 4, points: 230, stat: [14, 8] },
      { level: 5, points: 240, stat: [17.2, 10] },
      { level: 6, points: 250, stat: [20.4, 12] },
      { level: 7, points: 265, stat: [23.6, 14] },
      { level: 8, points: 280, stat: [26.6, 15.5] },
      { level: 9, points: 300, stat: [29.6, 17] },
      { level: 10, points: 320, stat: [32.6, 18.5] },
      { level: 11, points: 340, stat: [35.3, 20] },
      { level: 12, points: 360, stat: [38, 21.5] },
      { level: 13, points: 380, stat: [40.5, 23] },
      { level: 14, points: 400, stat: [42.8, 24] },
      { level: 15, points: 420, stat: [45, 25] }
    ]
  },
  {
    row: 'F',
    col: 1,
    type: 2,
    beast: 'all',
    description: 'Defense Expert',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 3 },
      { row: 'E', col: 1, minLevel: 4 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText: 'Reduces Damage taken by Troops while defending by $1%.',
    levels: [
      { level: 1, points: 255, stat: [1] },
      { level: 2, points: 275, stat: [2] },
      { level: 3, points: 295, stat: [3] },
      { level: 4, points: 315, stat: [4] },
      { level: 5, points: 335, stat: [5] },
      { level: 6, points: 355, stat: [6] },
      { level: 7, points: 380, stat: [7] },
      { level: 8, points: 405, stat: [8] },
      { level: 9, points: 435, stat: [9] },
      { level: 10, points: 465, stat: [10] },
      { level: 11, points: 495, stat: [11] },
      { level: 12, points: 530, stat: [12] },
      { level: 13, points: 565, stat: [13] },
      { level: 14, points: 600, stat: [14] },
      { level: 15, points: 640, stat: [15] }
    ]
  },
  {
    row: 'F',
    col: 2,
    type: 2,
    beast: 'all',
    description: 'Attack Master',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 3 },
      { row: 'E', col: 1, minLevel: 4 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText: 'Increases Damage dealt by Troops when attacking by $1%.',
    levels: [
      { level: 1, points: 255, stat: [1] },
      { level: 2, points: 275, stat: [2] },
      { level: 3, points: 295, stat: [3] },
      { level: 4, points: 315, stat: [4] },
      { level: 5, points: 335, stat: [5] },
      { level: 6, points: 355, stat: [6] },
      { level: 7, points: 380, stat: [7] },
      { level: 8, points: 405, stat: [8] },
      { level: 9, points: 435, stat: [9] },
      { level: 10, points: 465, stat: [10] },
      { level: 11, points: 495, stat: [11] },
      { level: 12, points: 530, stat: [12] },
      { level: 13, points: 565, stat: [13] },
      { level: 14, points: 600, stat: [14] },
      { level: 15, points: 640, stat: [15] }
    ]
  },
  {
    row: 'G',
    col: 1,
    type: 1,
    beast: 'pegasus',
    description: 'Battle Stampede',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 9 },
      { row: 'E', col: 1, minLevel: 9 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      "Launch Battle Stampede every 15 seconds in battle. Randomly increases 2 of your Troops' Attac by $1% and the Defense Penetration effect by $2% for 7 seconds. Prioritizes boosting the back row.",
    levels: [
      { level: 1, points: 560, stat: [2.1, 1.3] },
      { level: 2, points: 600, stat: [4.2, 2.6] },
      { level: 3, points: 640, stat: [6.4, 3.9] },
      { level: 4, points: 680, stat: [8.5, 5.2] },
      { level: 5, points: 720, stat: [10.6, 6.5] },
      { level: 6, points: 760, stat: [12.7, 7.8] },
      { level: 7, points: 800, stat: [14.9, 9.1] },
      { level: 8, points: 850, stat: [17, 10.4] },
      { level: 9, points: 900, stat: [19.1, 11.7] },
      { level: 10, points: 960, stat: [21.3, 13] },
      { level: 11, points: 1020, stat: [23.4, 14.2] },
      { level: 12, points: 1080, stat: [25.6, 15.4] },
      { level: 13, points: 1140, stat: [27.7, 16.6] },
      { level: 14, points: 1210, stat: [29.8, 17.8] },
      { level: 15, points: 1285, stat: [32, 19] }
    ]
  },
  {
    row: 'G',
    col: 1,
    type: 1,
    beast: 'phoenix',
    description: 'Flame Shield',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 9 },
      { row: 'E', col: 1, minLevel: 9 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      'Launch the Flame Shield every 15 seconds in battle. Randomly makes 2 of your Troops get Shield. Shield absorbs $1% Damage of your Troops current HP (up to $2) for 5 seconds. Prioritizes boosting the front row.',
    levels: [
      { level: 1, points: 560, stat: [0.9, 16000000] },
      { level: 2, points: 600, stat: [1.8, 32000000] },
      { level: 3, points: 640, stat: [2.7, 48000000] },
      { level: 4, points: 680, stat: [3.6, 64000000] },
      { level: 5, points: 720, stat: [4.5, 80000000] },
      { level: 6, points: 760, stat: [5.4, 96000000] },
      { level: 7, points: 800, stat: [6.3, 112000000] },
      { level: 8, points: 850, stat: [7.2, 128000000] },
      { level: 9, points: 900, stat: [8.1, 144000000] },
      { level: 10, points: 960, stat: [9, 160000000] },
      { level: 11, points: 1020, stat: [9.8, 176000000] },
      { level: 12, points: 1080, stat: [10.6, 192000000] },
      { level: 13, points: 1140, stat: [11.4, 208000000] },
      { level: 14, points: 1210, stat: [12.2, 224000000] },
      { level: 15, points: 1285, stat: [13, 240000000] }
    ]
  },
  {
    row: 'G',
    col: 1,
    type: 1,
    beast: 'panda',
    description: 'Tai Chi Matrix',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 9 },
      { row: 'E', col: 1, minLevel: 9 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      'Launch the Tai Chi Matrix every 15 seconds in battle. Randomly increases 2 of your Troops Defenses by $1% and reduces Damage by $2% for 7 seconds.',
    levels: [
      { level: 1, points: 560, stat: [2.1, 1.6] },
      { level: 2, points: 600, stat: [4.2, 3.2] },
      { level: 3, points: 640, stat: [6.4, 4.8] },
      { level: 4, points: 680, stat: [8.5, 6.4] },
      { level: 5, points: 720, stat: [10.6, 8] },
      { level: 6, points: 760, stat: [12.7, 9.6] },
      { level: 7, points: 800, stat: [14.9, 11.2] },
      { level: 8, points: 850, stat: [17, 12.8] },
      { level: 9, points: 900, stat: [19.1, 14.4] },
      { level: 10, points: 960, stat: [21.3, 16] },
      { level: 11, points: 1020, stat: [23.4, 17.6] },
      { level: 12, points: 1080, stat: [25.6, 19.2] },
      { level: 13, points: 1140, stat: [27.7, 20.8] },
      { level: 14, points: 1210, stat: [29.8, 22.4] },
      { level: 15, points: 1285, stat: [32, 24] }
    ]
  },
  {
    row: 'G',
    col: 1,
    type: 1,
    beast: 'dragon',
    description: 'Dragon Strength',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 9 },
      { row: 'E', col: 1, minLevel: 9 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      'Launch the Dragon Strength every 15 seconds in battle. Randomly increases 2 of your Troops Critical Strike Rate by $1% and the Critical Strike Damage by $2% for 7 seconds. Prioritizes boosting the back row.',
    levels: [
      { level: 1, points: 560, stat: [1.6, 10] },
      { level: 2, points: 600, stat: [3.3, 20] },
      { level: 3, points: 640, stat: [5, 30] },
      { level: 4, points: 680, stat: [6.6, 40] },
      { level: 5, points: 720, stat: [8.3, 50] },
      { level: 6, points: 760, stat: [10, 60] },
      { level: 7, points: 800, stat: [11.6, 70] },
      { level: 8, points: 850, stat: [13.3, 80] },
      { level: 9, points: 900, stat: [15, 90] },
      { level: 10, points: 960, stat: [16.6, 100] },
      { level: 11, points: 1020, stat: [18.3, 110] },
      { level: 12, points: 1080, stat: [20, 120] },
      { level: 13, points: 1140, stat: [21.6, 130] },
      { level: 14, points: 1210, stat: [23.3, 140] },
      { level: 15, points: 1285, stat: [25, 150] }
    ]
  },
  {
    row: 'H',
    col: 1,
    type: 2,
    beast: 'pegasus',
    description: 'F. Battle Stampede',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 9 },
      { row: 'E', col: 1, minLevel: 9 },
      { row: 'G', col: 1, minLevel: 3 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      'Your Troops fortified by Battle Stampede have their Attack increased by $1% and HP increased by $2% for 7 seconds.',
    levels: [
      { level: 1, points: 400, stat: [2, 2] },
      { level: 2, points: 420, stat: [4, 4] },
      { level: 3, points: 445, stat: [6, 6] },
      { level: 4, points: 465, stat: [8, 8] },
      { level: 5, points: 490, stat: [10, 10] },
      { level: 6, points: 515, stat: [12, 12] },
      { level: 7, points: 540, stat: [14, 14] },
      { level: 8, points: 570, stat: [16, 16] },
      { level: 9, points: 595, stat: [18, 18] },
      { level: 10, points: 625, stat: [20, 20] },
      { level: 11, points: 660, stat: [22.5, 22.5] },
      { level: 12, points: 695, stat: [25, 25] },
      { level: 13, points: 730, stat: [27.5, 27.5] },
      { level: 14, points: 765, stat: [30, 30] },
      { level: 15, points: 805, stat: [33, 33] }
    ]
  },
  {
    row: 'H',
    col: 1,
    type: 2,
    beast: 'phoenix',
    description: 'F. Flame Shield',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 9 },
      { row: 'E', col: 1, minLevel: 9 },
      { row: 'G', col: 1, minLevel: 3 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      'Your Troops fortified by Flame Shield have their Attack increased by $1% and HP increased by $2% for 7 seconds.',
    levels: [
      { level: 1, points: 400, stat: [2, 2] },
      { level: 2, points: 420, stat: [4, 4] },
      { level: 3, points: 445, stat: [6, 6] },
      { level: 4, points: 465, stat: [8, 8] },
      { level: 5, points: 490, stat: [10, 10] },
      { level: 6, points: 515, stat: [12, 12] },
      { level: 7, points: 540, stat: [14, 14] },
      { level: 8, points: 570, stat: [16, 16] },
      { level: 9, points: 595, stat: [18, 18] },
      { level: 10, points: 625, stat: [20, 20] },
      { level: 11, points: 660, stat: [22.5, 22.5] },
      { level: 12, points: 695, stat: [25, 25] },
      { level: 13, points: 730, stat: [27.5, 27.5] },
      { level: 14, points: 765, stat: [30, 30] },
      { level: 15, points: 805, stat: [33, 33] }
    ]
  },
  {
    row: 'H',
    col: 1,
    type: 2,
    beast: 'panda',
    description: 'F. Tai Chi Matrix',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 9 },
      { row: 'E', col: 1, minLevel: 9 },
      { row: 'G', col: 1, minLevel: 3 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      'Your Troops fortified by Tai Chi Matrix have their Attack increased by $1% and HP increased by $2% for 7 seconds.',
    levels: [
      { level: 1, points: 400, stat: [2, 2] },
      { level: 2, points: 420, stat: [4, 4] },
      { level: 3, points: 445, stat: [6, 6] },
      { level: 4, points: 465, stat: [8, 8] },
      { level: 5, points: 490, stat: [10, 10] },
      { level: 6, points: 515, stat: [12, 12] },
      { level: 7, points: 540, stat: [14, 14] },
      { level: 8, points: 570, stat: [16, 16] },
      { level: 9, points: 595, stat: [18, 18] },
      { level: 10, points: 625, stat: [20, 20] },
      { level: 11, points: 660, stat: [22.5, 22.5] },
      { level: 12, points: 695, stat: [25, 25] },
      { level: 13, points: 730, stat: [27.5, 27.5] },
      { level: 14, points: 765, stat: [30, 30] },
      { level: 15, points: 805, stat: [33, 33] }
    ]
  },
  {
    row: 'H',
    col: 1,
    type: 2,
    beast: 'dragon',
    description: 'F. Dragon Strength',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 9 },
      { row: 'E', col: 1, minLevel: 9 },
      { row: 'G', col: 1, minLevel: 3 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      'Your Troops fortified by Dragon Strength have their Attack increased by $1% and HP increased by $2% for 7 seconds.',
    levels: [
      { level: 1, points: 400, stat: [2, 2] },
      { level: 2, points: 420, stat: [4, 4] },
      { level: 3, points: 445, stat: [6, 6] },
      { level: 4, points: 465, stat: [8, 8] },
      { level: 5, points: 490, stat: [10, 10] },
      { level: 6, points: 515, stat: [12, 12] },
      { level: 7, points: 540, stat: [14, 14] },
      { level: 8, points: 570, stat: [16, 16] },
      { level: 9, points: 595, stat: [18, 18] },
      { level: 10, points: 625, stat: [20, 20] },
      { level: 11, points: 660, stat: [22.5, 22.5] },
      { level: 12, points: 695, stat: [25, 25] },
      { level: 13, points: 730, stat: [27.5, 27.5] },
      { level: 14, points: 765, stat: [30, 30] },
      { level: 15, points: 805, stat: [33, 33] }
    ]
  },
  {
    row: 'H',
    col: 2,
    type: 2,
    beast: 'all',
    description: 'Angel Rebirth',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 9 },
      { row: 'E', col: 1, minLevel: 9 },
      { row: 'G', col: 1, minLevel: 3 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText: 'Increases HP and Attack of Angels by $1%.',
    levels: [
      { level: 1, points: 440, stat: [1.3] },
      { level: 2, points: 460, stat: [2.6] },
      { level: 3, points: 485, stat: [3.9] },
      { level: 4, points: 510, stat: [5.3] },
      { level: 5, points: 535, stat: [6.7] },
      { level: 6, points: 560, stat: [8.1] },
      { level: 7, points: 590, stat: [9.6] },
      { level: 8, points: 620, stat: [11.1] },
      { level: 9, points: 650, stat: [12.6] },
      { level: 10, points: 685, stat: [14.1] },
      { level: 11, points: 720, stat: [15.6] },
      { level: 12, points: 755, stat: [17.2] },
      { level: 13, points: 795, stat: [18.8] },
      { level: 14, points: 835, stat: [20.4] },
      { level: 15, points: 875, stat: [22] }
    ]
  },
  {
    row: 'I',
    col: 1,
    type: 1,
    beast: 'all',
    description: 'Strength Combo',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 9 },
      { row: 'E', col: 1, minLevel: 9 },
      { row: 'G', col: 1, minLevel: 1 },
      { row: 'B', col: 2, minLevel: 12 },
      { row: 'D', col: 2, minLevel: 12 }
    ],
    dependencyBlevel: 12,
    dependencyB: [
      { row: 'B', col: 2, minLevel: 15 },
      { row: 'D', col: 2, minLevel: 15 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      'The Beast launches the double strike every 6 seconds, continuosly dealing Damage 5 times against the attacked target. Each Damage is $1% of your current Attack. This Damage is True Damage and ignores Defense, Damage Reduction, Shield, and Dodge.',
    levels: [
      { level: 1, points: 795, stat: [21] },
      { level: 2, points: 845, stat: [42] },
      { level: 3, points: 895, stat: [62] },
      { level: 4, points: 945, stat: [82] },
      { level: 5, points: 1005, stat: [100] },
      { level: 6, points: 1065, stat: [118] },
      { level: 7, points: 1130, stat: [136] },
      { level: 8, points: 1195, stat: [153] },
      { level: 9, points: 1260, stat: [170] },
      { level: 10, points: 1340, stat: [187] },
      { level: 11, points: 1420, stat: [203] },
      { level: 12, points: 1500, stat: [219] },
      { level: 13, points: 1595, stat: [233] },
      { level: 14, points: 1695, stat: [247] },
      { level: 15, points: 1795, stat: [260] }
    ]
  },
  {
    row: 'J',
    col: 1,
    type: 2,
    beast: 'all',
    description: 'F. Strength Combo',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'C', col: 1, minLevel: 9 },
      { row: 'E', col: 1, minLevel: 9 },
      { row: 'G', col: 1, minLevel: 1 },
      { row: 'B', col: 2, minLevel: 12 },
      { row: 'D', col: 2, minLevel: 12 },
      { row: 'I', col: 1, minLevel: 1 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText: 'Increases Damage of Strength Combo by $1%.',
    levels: [
      { level: 1, points: 485, stat: [6] },
      { level: 2, points: 510, stat: [12] },
      { level: 3, points: 540, stat: [18] },
      { level: 4, points: 565, stat: [24] },
      { level: 5, points: 595, stat: [30] },
      { level: 6, points: 625, stat: [36.5] },
      { level: 7, points: 655, stat: [43.5] },
      { level: 8, points: 690, stat: [50.5] },
      { level: 9, points: 725, stat: [57] },
      { level: 10, points: 760, stat: [64] },
      { level: 11, points: 800, stat: [71] },
      { level: 12, points: 840, stat: [78] },
      { level: 13, points: 880, stat: [85] },
      { level: 14, points: 925, stat: [92.5] },
      { level: 15, points: 975, stat: [100] }
    ]
  },
  {
    row: 'J',
    col: 2,
    type: 2,
    beast: 'pegasus',
    description: 'Spirit Flood',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'G', col: 1, minLevel: 1 },
      { row: 'B', col: 2, minLevel: 12 },
      { row: 'D', col: 2, minLevel: 12 },
      { row: 'C', col: 1, minLevel: 15 },
      { row: 'E', col: 1, minLevel: 15 },
      { row: 'G', col: 1, minLevel: 15 },
      { row: 'I', col: 1, minLevel: 9 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText: 'Increases the Damage dealt against Infantry and Cavalry by $1%.',
    levels: [
      { level: 1, points: 530, stat: [1.2] },
      { level: 2, points: 555, stat: [2.4] },
      { level: 3, points: 580, stat: [3.6] },
      { level: 4, points: 610, stat: [4.8] },
      { level: 5, points: 640, stat: [6] },
      { level: 6, points: 675, stat: [7.3] },
      { level: 7, points: 710, stat: [8.6] },
      { level: 8, points: 745, stat: [9.9] },
      { level: 9, points: 785, stat: [11.3] },
      { level: 10, points: 825, stat: [12.7] },
      { level: 11, points: 865, stat: [14.1] },
      { level: 12, points: 910, stat: [15.5] },
      { level: 13, points: 955, stat: [17] },
      { level: 14, points: 1005, stat: [18.5] },
      { level: 15, points: 1055, stat: [20] }
    ]
  },
  {
    row: 'J',
    col: 2,
    type: 2,
    beast: 'phoenix',
    description: 'Rebirth Flame',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'G', col: 1, minLevel: 1 },
      { row: 'B', col: 2, minLevel: 12 },
      { row: 'D', col: 2, minLevel: 12 },
      { row: 'C', col: 1, minLevel: 15 },
      { row: 'E', col: 1, minLevel: 15 },
      { row: 'G', col: 1, minLevel: 15 },
      { row: 'I', col: 1, minLevel: 9 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText: 'Increases Damage of Angels by $1%.',
    levels: [
      { level: 1, points: 530, stat: [1] },
      { level: 2, points: 555, stat: [2] },
      { level: 3, points: 580, stat: [3] },
      { level: 4, points: 610, stat: [4] },
      { level: 5, points: 640, stat: [5] },
      { level: 6, points: 675, stat: [6] },
      { level: 7, points: 710, stat: [7] },
      { level: 8, points: 745, stat: [8] },
      { level: 9, points: 785, stat: [9] },
      { level: 10, points: 825, stat: [10] },
      { level: 11, points: 865, stat: [11] },
      { level: 12, points: 910, stat: [12] },
      { level: 13, points: 955, stat: [13] },
      { level: 14, points: 1005, stat: [14] },
      { level: 15, points: 1055, stat: [15] }
    ]
  },
  {
    row: 'J',
    col: 2,
    type: 2,
    beast: 'panda',
    description: 'Holy Blessing',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'G', col: 1, minLevel: 1 },
      { row: 'B', col: 2, minLevel: 12 },
      { row: 'D', col: 2, minLevel: 12 },
      { row: 'C', col: 1, minLevel: 15 },
      { row: 'E', col: 1, minLevel: 15 },
      { row: 'G', col: 1, minLevel: 15 },
      { row: 'I', col: 1, minLevel: 9 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText: 'Reduces Damage taken by Troops by $1%.',
    levels: [
      { level: 1, points: 530, stat: [1] },
      { level: 2, points: 555, stat: [2] },
      { level: 3, points: 580, stat: [3] },
      { level: 4, points: 610, stat: [4] },
      { level: 5, points: 640, stat: [5] },
      { level: 6, points: 675, stat: [6] },
      { level: 7, points: 710, stat: [7] },
      { level: 8, points: 745, stat: [8] },
      { level: 9, points: 785, stat: [9] },
      { level: 10, points: 825, stat: [10] },
      { level: 11, points: 865, stat: [11] },
      { level: 12, points: 910, stat: [12] },
      { level: 13, points: 955, stat: [13] },
      { level: 14, points: 1005, stat: [14] },
      { level: 15, points: 1055, stat: [15] }
    ]
  },
  {
    row: 'J',
    col: 2,
    type: 2,
    beast: 'dragon',
    description: 'Dragon Scale',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 1 },
      { row: 'G', col: 1, minLevel: 1 },
      { row: 'B', col: 2, minLevel: 12 },
      { row: 'D', col: 2, minLevel: 12 },
      { row: 'C', col: 1, minLevel: 15 },
      { row: 'E', col: 1, minLevel: 15 },
      { row: 'G', col: 1, minLevel: 15 },
      { row: 'I', col: 1, minLevel: 9 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText: 'Increases Damage of Archers and Mages by $1%. Reduces Damage Taken by Infantry and Cavalry by $1%.',
    levels: [
      { level: 1, points: 530, stat: [0.5] },
      { level: 2, points: 555, stat: [1] },
      { level: 3, points: 580, stat: [1.5] },
      { level: 4, points: 610, stat: [2] },
      { level: 5, points: 640, stat: [2.5] },
      { level: 6, points: 675, stat: [3] },
      { level: 7, points: 710, stat: [3.5] },
      { level: 8, points: 745, stat: [4] },
      { level: 9, points: 785, stat: [4.5] },
      { level: 10, points: 825, stat: [5] },
      { level: 11, points: 865, stat: [5.5] },
      { level: 12, points: 910, stat: [6] },
      { level: 13, points: 955, stat: [6.5] },
      { level: 14, points: 1005, stat: [7] },
      { level: 15, points: 1055, stat: [7.5] }
    ]
  },
  {
    row: 'K',
    col: 1,
    type: 1,
    beast: 'all',
    description: 'Troops Command',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 15 },
      { row: 'B', col: 1, minLevel: 15 },
      { row: 'B', col: 2, minLevel: 12 },
      { row: 'C', col: 1, minLevel: 15 },
      { row: 'D', col: 1, minLevel: 15 },
      { row: 'D', col: 2, minLevel: 12 },
      { row: 'E', col: 1, minLevel: 15 },
      { row: 'F', col: 1, minLevel: 15 },
      { row: 'F', col: 2, minLevel: 15 },
      { row: 'G', col: 1, minLevel: 15 },
      { row: 'H', col: 1, minLevel: 15 },
      { row: 'H', col: 2, minLevel: 15 },
      { row: 'I', col: 1, minLevel: 15 },
      { row: 'J', col: 1, minLevel: 15 },
      { row: 'J', col: 2, minLevel: 15 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText: 'Increases the Army Size by an additional $1.',
    levels: [
      { level: 1, points: 600, stat: [580] },
      { level: 2, points: 750, stat: [1160] },
      { level: 3, points: 900, stat: [1740] },
      { level: 4, points: 1070, stat: [2320] },
      { level: 5, points: 1260, stat: [2900] },
      { level: 6, points: 1450, stat: [3480] },
      { level: 7, points: 1640, stat: [4060] },
      { level: 8, points: 1830, stat: [4640] },
      { level: 9, points: 2030, stat: [5220] },
      { level: 10, points: 2230, stat: [5800] },
      { level: 11, points: 2430, stat: [6380] },
      { level: 12, points: 2630, stat: [6960] },
      { level: 13, points: 2840, stat: [7540] },
      { level: 14, points: 3060, stat: [8120] },
      { level: 15, points: 3280, stat: [8700] }
    ]
  },
  {
    row: 'L',
    col: 1,
    type: 2,
    beast: 'all',
    description: 'Beast Coercion',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 15 },
      { row: 'B', col: 1, minLevel: 15 },
      { row: 'B', col: 2, minLevel: 12 },
      { row: 'C', col: 1, minLevel: 15 },
      { row: 'D', col: 1, minLevel: 15 },
      { row: 'D', col: 2, minLevel: 12 },
      { row: 'E', col: 1, minLevel: 15 },
      { row: 'F', col: 1, minLevel: 15 },
      { row: 'F', col: 2, minLevel: 15 },
      { row: 'G', col: 1, minLevel: 15 },
      { row: 'H', col: 1, minLevel: 15 },
      { row: 'H', col: 2, minLevel: 15 },
      { row: 'I', col: 1, minLevel: 15 },
      { row: 'J', col: 1, minLevel: 15 },
      { row: 'J', col: 2, minLevel: 15 },
      { row: 'K', col: 1, minLevel: 5 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      "When the battle starts, the Beast casts the 'Coercion' effect on the enemy's Archers and Mages, reducing their Damage dealt by $1% until battle is over.",
    levels: [
      { level: 1, points: 800, stat: [0.8] },
      { level: 2, points: 1000, stat: [1.6] },
      { level: 3, points: 1230, stat: [2.4] },
      { level: 4, points: 1480, stat: [3.2] },
      { level: 5, points: 1730, stat: [4] },
      { level: 6, points: 1980, stat: [4.8] },
      { level: 7, points: 2230, stat: [5.6] },
      { level: 8, points: 2480, stat: [6.4] },
      { level: 9, points: 2750, stat: [7.2] },
      { level: 10, points: 3020, stat: [8] },
      { level: 11, points: 3290, stat: [8.8] },
      { level: 12, points: 3560, stat: [9.6] },
      { level: 13, points: 3850, stat: [10.4] },
      { level: 14, points: 4150, stat: [11.2] },
      { level: 15, points: 4450, stat: [12] }
    ]
  },
  {
    row: 'L',
    col: 2,
    type: 2,
    beast: 'all',
    description: 'Beast Mark',
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 15 },
      { row: 'B', col: 1, minLevel: 15 },
      { row: 'B', col: 2, minLevel: 12 },
      { row: 'C', col: 1, minLevel: 15 },
      { row: 'D', col: 1, minLevel: 15 },
      { row: 'D', col: 2, minLevel: 12 },
      { row: 'E', col: 1, minLevel: 15 },
      { row: 'F', col: 1, minLevel: 15 },
      { row: 'F', col: 2, minLevel: 15 },
      { row: 'G', col: 1, minLevel: 15 },
      { row: 'H', col: 1, minLevel: 15 },
      { row: 'H', col: 2, minLevel: 15 },
      { row: 'I', col: 1, minLevel: 15 },
      { row: 'J', col: 1, minLevel: 15 },
      { row: 'J', col: 2, minLevel: 15 },
      { row: 'K', col: 1, minLevel: 5 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText:
      'When attacking Lords, the Beast applies the Beast Mark to your Archers and Mages after the battle starts, increasing their Damage dealt by $1% until the battle is over and reducing the Damage Taken by the Beast by $2%.',
    levels: [
      { level: 1, points: 800, stat: [0.8, 2] },
      { level: 2, points: 1000, stat: [1.6, 4] },
      { level: 3, points: 1230, stat: [2.4, 6] },
      { level: 4, points: 1480, stat: [3.2, 8] },
      { level: 5, points: 1730, stat: [4, 10] },
      { level: 6, points: 1980, stat: [4.8, 12] },
      { level: 7, points: 2230, stat: [5.6, 14] },
      { level: 8, points: 2480, stat: [6.4, 16] },
      { level: 9, points: 2750, stat: [7.2, 18] },
      { level: 10, points: 3020, stat: [8, 20] },
      { level: 11, points: 3290, stat: [8.8, 22] },
      { level: 12, points: 3560, stat: [9.6, 24] },
      { level: 13, points: 3850, stat: [10.4, 26] },
      { level: 14, points: 4150, stat: [11.2, 28] },
      { level: 15, points: 4450, stat: [12, 30] }
    ]
  },
  {
    row: 'M',
    col: 1,
    type: 1,
    beast: 'all',
    description: "Beast's Rage",
    counter: 0,
    maxCounter: 15,
    minCounter: 0,
    beastMinLevel: 12,
    dependency: [
      { row: 'A', col: 1, minLevel: 15 },
      { row: 'B', col: 1, minLevel: 15 },
      { row: 'B', col: 2, minLevel: 12 },
      { row: 'C', col: 1, minLevel: 15 },
      { row: 'D', col: 1, minLevel: 15 },
      { row: 'D', col: 2, minLevel: 12 },
      { row: 'E', col: 1, minLevel: 15 },
      { row: 'F', col: 1, minLevel: 15 },
      { row: 'F', col: 2, minLevel: 15 },
      { row: 'G', col: 1, minLevel: 15 },
      { row: 'H', col: 1, minLevel: 15 },
      { row: 'H', col: 2, minLevel: 15 },
      { row: 'I', col: 1, minLevel: 15 },
      { row: 'J', col: 1, minLevel: 15 },
      { row: 'J', col: 2, minLevel: 15 },
      { row: 'K', col: 1, minLevel: 8 },
      { row: 'L', col: 1, minLevel: 8 },
      { row: 'L', col: 2, minLevel: 8 }
    ],
    curLevel: 0,
    curTotalPoints: 0,
    statText: 'Increases Damage of Troops by $1%.',
    levels: [
      { level: 1, points: 1300, stat: [0.7] },
      { level: 2, points: 1470, stat: [1.4] },
      { level: 3, points: 1670, stat: [2.1] },
      { level: 4, points: 1910, stat: [2.8] },
      { level: 5, points: 2200, stat: [3.5] },
      { level: 6, points: 2550, stat: [4.2] },
      { level: 7, points: 2900, stat: [4.9] },
      { level: 8, points: 3250, stat: [5.6] },
      { level: 9, points: 3600, stat: [6.3] },
      { level: 10, points: 3950, stat: [7] },
      { level: 11, points: 4310, stat: [7.7] },
      { level: 12, points: 4670, stat: [8.4] },
      { level: 13, points: 5035, stat: [9.1] },
      { level: 14, points: 5405, stat: [9.8] },
      { level: 15, points: 5780, stat: [10.5] }
    ]
  }
]
